import { IoTriangle } from 'react-icons/io5';
import { TbTriangleInvertedFilled } from 'react-icons/tb';
import { toLocaleFixedNumber, toSpecialFixed } from '@/lib/misc/utils';
import { useSession } from '@/contexts/LitSessionProvider';
import { Address } from 'viem';
import { usePortfolioChartData } from '@/hooks/charts/usePortfolioChartData';
import { Skeleton } from '@/components/ui/skeleton';
const ChartPriceHeader = ({
  currentPrice,
  assetData,
  currentResolution
}) => {
  const {
    PKP
  } = useSession();
  const {
    data: chartBarData,
    isLoading: isLoadingChartBarData
  } = usePortfolioChartData({
    ethWallet: PKP?.additionalEthAddress as Address,
    solanaWallet: PKP?.solanaAddress as string,
    currentResolution
  });
  const value0 = chartBarData?.[0]?.value;
  const lastValue = chartBarData?.[chartBarData?.length - 1]?.value;
  const usdChange = lastValue - value0;
  const percentChange = (lastValue - value0) / value0 * 100;
  return <div className='relative flex flex-col pt-6 px-6 w-full' data-sentry-component="ChartPriceHeader" data-sentry-source-file="ChartPriceHeader.tsx">
      {!PKP ? <></> : <>
          {' '}
          <div className='flex w-full'>
            <div className={`transition-all w-full`}>
              <div className='text-genius-cream text-3xl font-medium tracking-tighter'>
                {currentPrice ? <div className='flex'>
                    <div className='flex-col text-3xl'>$</div>
                    {currentPrice?.value ? toSpecialFixed(currentPrice.value, 2)?.value : '0'}
                  </div> : <div className='flex items-center justify-center w-full mx-auto '>
                    <Skeleton className='w-full h-12' />
                  </div>}
              </div>
            </div>
          </div>
          <div className='flex items-center mt-5'>
            {isNaN(usdChange) && <Skeleton className='w-1/5 h-6' />}
            {assetData && !isNaN(usdChange) && <>
                {usdChange >= 0 ? <IoTriangle color='#34D399' size={12} /> : <TbTriangleInvertedFilled color='#FF5B5B' size={12} />}
                <p className={`${usdChange >= 0 ? 'text-green-400' : 'text-red-400'} text-xs font-normal ml-1`}>
                  ${toLocaleFixedNumber(Math.abs(usdChange))}{' '}
                  {assetData?.totalUsdValue24h ? '(' + toLocaleFixedNumber(Math.abs(percentChange)) + '%)' : ''}
                </p>

                {currentResolution && currentResolution.periodLabel && <p className='text-genius-dark text-xs font-normal ml-3'>
                    {currentResolution.periodLabel === '1H' ? 'Past Hour' : currentResolution.periodLabel === '1D' ? 'Today' : currentResolution.periodLabel === '1W' ? 'Past Week' : currentResolution.periodLabel === '1M' ? 'Past Month' : currentResolution.periodLabel === '3M' ? 'Past 3 Months' : currentResolution.periodLabel === '1Y' ? 'Past Year' : 'All Time'}
                  </p>}
              </>}
          </div>
        </>}
    </div>;
};
export default ChartPriceHeader;